exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexRow[data-v-df323ca6]{justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-df323ca6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/CategoryView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-df323ca6&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/CategoryView.vue
// module chunks = 0